var _path, _path2, _path3, _ellipse, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6027 12.1029C17.8305 8.50246 23.1901 8.02417 24.5343 9.32887C24.8955 9.67944 25.6335 10.8161 25.8462 11.959C22.5823 12.5344 20.945 14.1577 19.1918 17.692C17.9057 20.2847 16.3012 21.1413 15.0291 21.8205L15.0291 21.8205L15.029 21.8205C14.7788 21.9541 14.5414 22.0808 14.3219 22.2126C14.3219 23.0002 14.0201 24.2869 13.3206 25.4621C13.0894 25.8505 12.8147 26.2268 12.4931 26.5688C11.4694 27.6575 9.64845 28.2579 8.56479 28.4618C8.5286 28.4686 8.50334 28.4282 8.52561 28.3989C8.61451 28.2818 8.71306 28.1632 8.81737 28.0376L8.81742 28.0376L8.81746 28.0375C9.28277 27.4776 9.86273 26.7797 10.2123 25.4592C10.2621 25.2708 10.2898 25.0653 10.2991 24.8515C10.3426 23.8589 9.99195 22.6859 9.63693 22.2126C8.13692 21.9249 5.5684 20.4249 4.27387 19.0687C3.07927 17.8172 2.62178 16.5582 2.50673 16.1351C2.18477 14.5657 2.30985 13.2658 2.50673 12.2467C2.70533 11.2186 3.38665 9.97134 3.96903 8.90517C4.41096 8.09612 4.79592 7.39137 4.86976 6.96583C3.6681 6.63551 3.29298 5.50216 2.96555 4.51292C2.82451 4.08679 2.69232 3.6874 2.50673 3.39046C2.03744 2.63961 1.25805 1.84162 0.876783 1.48872C0.852957 1.46667 0.862607 1.42731 0.894061 1.41927C1.27885 1.32089 1.91154 1.20945 2.56369 1.20271C2.62147 1.20212 2.6794 1.20234 2.73733 1.20347C3.19357 1.21236 3.64943 1.27733 4.02729 1.43838C5.03004 1.86578 5.86977 2.91785 6.1643 3.39046C6.39717 3.15073 7.18348 2.60141 8.46569 2.32195C9.62775 2.06868 11.4627 2.76395 12.4592 3.24828C12.5024 3.26931 12.4768 3.35053 12.4288 3.34717C11.945 3.31329 11.1611 3.38606 10.4178 3.84252C10.0242 4.08415 9.78613 4.52295 9.52393 5.00617C9.00572 5.96116 8.39339 7.08961 6.30123 7.21241C6.24246 7.49893 6.16053 7.79841 6.076 8.10742C5.73347 9.35951 5.34818 10.7679 6.28758 12.1029C7.45883 13.7673 10.4178 14.8152 13.6027 12.1029Z",
    fill: "#97A1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6439 23.9386C25.4185 20.6475 26.4564 15.2376 25.8462 11.959C22.5823 12.5344 20.945 14.1577 19.1918 17.692C17.9057 20.2847 16.3012 21.1413 15.0291 21.8205L15.0291 21.8205L15.029 21.8205C14.7788 21.9541 14.5414 22.0808 14.3219 22.2126C14.3219 23.0002 14.0201 24.2869 13.3206 25.4621C15.3196 25.5875 17.4763 25.174 19.6439 23.9386Z",
    fill: "url(#paint0_linear_434_743)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63693 22.2126C8.13692 21.9249 5.5684 20.4249 4.27387 19.0687C3.07927 17.8172 2.62178 16.5582 2.50673 16.1351C2.75601 17.3503 3.2733 18.7271 4.23277 20.2605C5.33649 22.0244 7.53797 23.9004 10.2991 24.8515C10.3426 23.8589 9.99195 22.6859 9.63693 22.2126Z",
    fill: "url(#paint1_linear_434_743)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.7399,
    cy: 14.4659,
    rx: 0.575348,
    ry: 0.575348,
    fill: "#4A4A4A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9179,
    cy: 1.23289,
    r: 1.23289,
    fill: "url(#paint2_linear_434_743)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9179,
    cy: 1.23289,
    r: 1.23289,
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.821926,
    cy: 22.2331,
    r: 0.821926,
    fill: "url(#paint3_linear_434_743)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.821926,
    cy: 22.2331,
    r: 0.821926,
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.959,
    cy: 24.8633,
    r: 1.02741,
    fill: "url(#paint4_linear_434_743)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.959,
    cy: 24.8633,
    r: 1.02741,
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.80849,
    cy: 26.0961,
    r: 1.43837,
    fill: "url(#paint5_linear_434_743)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.80849,
    cy: 26.0961,
    r: 1.43837,
    stroke: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4523,
    cy: 6.3288,
    r: 2.05481,
    fill: "url(#paint6_linear_434_743)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4523,
    cy: 6.3288,
    r: 2.05481,
    stroke: "black"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.11,
    cy: 5.50692,
    r: 0.821926,
    fill: "url(#paint7_linear_434_743)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.11,
    cy: 5.50692,
    r: 0.821926,
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_434_743",
    x1: 13.4108,
    y1: 1.20239,
    x2: 13.4108,
    y2: 28.4797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_434_743",
    x1: 13.4108,
    y1: 1.20239,
    x2: 13.4108,
    y2: 28.4797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_434_743",
    x1: 17.9179,
    y1: 0,
    x2: 17.9179,
    y2: 2.46578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_434_743",
    x1: 0.821926,
    y1: 21.4112,
    x2: 0.821926,
    y2: 23.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_434_743",
    x1: 23.959,
    y1: 23.8359,
    x2: 23.959,
    y2: 25.8907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_434_743",
    x1: 4.80849,
    y1: 24.6578,
    x2: 4.80849,
    y2: 27.5345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_434_743",
    x1: 15.4523,
    y1: 4.27399,
    x2: 15.4523,
    y2: 8.38362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEDDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_434_743",
    x1: 22.11,
    y1: 4.685,
    x2: 22.11,
    y2: 6.32885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEDDFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPurple);
export default __webpack_public_path__ + "static/media/logoPurple.72e24cb6d9d99d9af15d7849c2351976.svg";
export { ForwardRef as ReactComponent };